<template>
    <!-- main start  -->
    <div id="main">
        <!-- Main Header -->
        <MainHeader />
        
        <!-- Top Header -->
        <div class="top-header top-header-half">
            <div class="page-subtitle">
                <span>404 - Not Found</span>
            </div>
        </div>
        <!-- top-header end-->
        
        <!-- wrapper  -->	
        <div id="wrapper">
            <!-- content-holder  -->	
            <div class="content-holder" data-pagetitle="404">
                <!-- Navigation -->
                <Navigation />
                
                <!-- content-->
                <div class="content full-height">
                    <div class="column-wrap">
                        <div class="column-wrap-container white-bg fl-wrap">
                            <div class="col-wc_dec"></div>
                            
                            <section class="scroll-con-sec">
                                <div class="container">
                                    <div class="section-title fl-wrap">
                                        <h2>404 <strong>Page Not Found</strong></h2>
                                        <p>The page you are looking for doesn't exist or has been moved.</p>
                                        <div class="sec-title_dec"></div>
                                    </div>
                                    
                                    <div class="column-wrapper_text fl-wrap text-center">
                                        <div class="error-code">
                                            <h1>404</h1>
                                        </div>
                                        <p>We're sorry, but the page you were looking for could not be found.</p>
                                        <router-link to="/" class="btn float-btn">
                                            <span>Back to Homepage</span>
                                        </router-link>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
                <!-- content end  -->
                
                <div class="limit-box fl-wrap"></div>
                
                <!-- Footer -->
                <AppFooter />
                
            </div>
            <!-- content-holder end -->
        </div>
        <!-- wrapper end -->
        
        <!-- cursor-->
        <div class="element">
            <div class="element-item"></div>
        </div>
        <!-- cursor end-->
    </div>
    <!-- Main end -->
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
import Navigation from '@/components/Navigation.vue'
import AppFooter from '@/components/Common/AppFooter.vue'

export default {
    name: 'NotFound',
    components: {
        MainHeader,
        Navigation,
        AppFooter
    },
    data() {
        return {
        }
    },
    mounted() {
        document.title = '404 - Page Not Found'
        // Initialize theme
        this.$nextTick(() => {
            if (this.$initTheme) {
                this.$initTheme()
            }
        })
    }
}
</script>

<style scoped>
.error-code h1 {
    font-size: 150px;
    font-weight: 700;
    margin: 30px 0;
    color: #ccc;
}

.text-center {
    text-align: center;
}
</style>
